import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {PTOFacade} from "../../facade/pto.facade";
import {combineLatest, map} from "rxjs";
import {ProjectRequestDto} from "../../dto/project-request.dto";
import { ModalService } from 'src/app/services/modal.service';
import { GenericConfirmModalComponent } from 'src/app/components/modals/generic-confirm-modal/generic-confirm-modal.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-project-team-overview-main',
  templateUrl: './project-team-overview-main.component.html',
  styleUrls: ['./project-team-overview-main.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectTeamOverviewMainComponent implements OnInit {
  readonly vm$ = combineLatest([
    this.projectFacade.projects$,
    this.projectFacade.loading$,
    this.projectFacade.aggregateValues$,
    this.projectFacade.projectTypes$,
    this.projectFacade.projectDefaultCategories$,
    this.projectFacade.loadingProjects$,
    this.projectFacade.quickMenuData$
  ]).pipe(
    map(([projects, loading, aggregateValues, projectTypes, projectDefaultCategories, loadingProjects, quickMenuData]) => ({
      projects,
      loading,
      aggregateValues,
      projectTypes,
      projectDefaultCategories,
      loadingProjects,
      quickMenuData
    })),
  );

  private requestPayload: ProjectRequestDto = {
    projectUuid: '',
    filters: {
      sort: 'ASC',
      projects: [],
      projectTypeUuid: '',
      categoryUuid: ''
    },
    params: {
      page: 1,
      limit: 5,
    }
  }

  public projectTypeFilter: string | null = null;
  public projectSortFilter: string | null = null;
  public projectIndicatorFilter: string | null = null;

  constructor(private projectFacade: PTOFacade, private modalService: ModalService, private router: Router) { }

  ngOnInit(): void {
    this.projectFacade.loadData(this.requestPayload);
  }

  changeProjectType(type: any) {
    this.requestPayload.filters.projectTypeUuid = type ? type.uuid : '';
    this.projectTypeFilter = type;
    this.projectFacade.onFiltersLoadProjects(this.requestPayload, this.projectFacade.intervals);
  }

  changeProjectSort(sortBy: any) {
    this.requestPayload.filters.sort = sortBy;
    this.projectSortFilter = sortBy;
    this.projectFacade.onFiltersLoadProjects(this.requestPayload, this.projectFacade.intervals);
  }

  changeProjectIndicatorSort(event: any) {
    this.projectIndicatorFilter = event;
    this.requestPayload.filters.categoryUuid = event ? event.uuid : '';
    this.projectFacade.onFiltersLoadProjects(this.requestPayload, this.projectFacade.intervals);
  }

  loadQuickActionsMenuData(projectUuid: string): void {
    this.projectFacade.loadQuickActionsMenuData(projectUuid);
  }

  openPauseOrResumeProjectModal(data: any) {
    this.modalService.openModal(GenericConfirmModalComponent,
      {
        title: {
          key: `modal_title_project_team_${data.action}_project`
        },
        description: {
          key: `modal_description_project_team_${data.action}_project`,
        },
        buttons: [
          {labelKey: `modal_confirmation_btn_project_team_${data.action}_project`, value: true, className: 'yes-btn'},
          {labelKey: `modal_cancel_btn_project_team_${data.action}_project`, value: false, className: 'no-btn'}
        ]
      },
      {panelClass: 'generic-modal'}
    )
    .afterClosed()
    .subscribe(result => {
      if (result && data.action === 'pause') {
        this.projectFacade.pauseProject(data.data);
      }

      if(result && data.action === 'resume') {
        this.projectFacade.resumeProject(data.data);
      }
    });
  }

  goToProjectDashboard(event: any) {
    this.router.navigate(['project-team-dashboard/'+event.project.uuid]);
  }

}
